import { render, staticRenderFns } from "./IsBlocked.vue?vue&type=template&id=033c24bc&scoped=true&"
import script from "./IsBlocked.vue?vue&type=script&lang=js&"
export * from "./IsBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033c24bc",
  null
  
)

export default component.exports